<template>
	<div class="quote-card">
		<QuoteCardTitle class="mb-4">Financial Health</QuoteCardTitle>
		<div class="grid grid-cols-2 md:grid-cols-3 gap-4">
			<div
				v-for="(item, idx) in cards"
				:key="idx"
				class="bg-white border border-slate-200 rounded-lg p-2 lg:p-5 flex flex-col gap-2"
			>
				<div class="flex flex-col lg:flex-row items-start gap-3">
					<svg
						v-if="item.icon === 'pie'"
						width="25"
						height="24"
						viewBox="0 0 25 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M17.7 14C17.977 14 18.1155 14 18.2278 14.0616C18.3204 14.1123 18.4065 14.2076 18.4478 14.3048C18.4978 14.4226 18.4852 14.548 18.46 14.7987C18.3296 16.0988 17.8822 17.3515 17.1518 18.4446C16.2727 19.7602 15.0233 20.7856 13.5615 21.3911C12.0997 21.9966 10.4911 22.155 8.93928 21.8463C7.38743 21.5376 5.96197 20.7757 4.84315 19.6569C3.72433 18.5381 2.9624 17.1126 2.65372 15.5608C2.34504 14.0089 2.50347 12.4004 3.10897 10.9386C3.71447 9.47677 4.73985 8.22734 6.05544 7.34829C7.14856 6.61789 8.40125 6.17045 9.70131 6.04001C9.95207 6.01485 10.0774 6.00227 10.1953 6.05226C10.2925 6.0935 10.3878 6.1797 10.4385 6.2723C10.5 6.38455 10.5 6.52305 10.5 6.80005V13.2C10.5 13.4801 10.5 13.6201 10.5545 13.727C10.6024 13.8211 10.6789 13.8976 10.773 13.9456C10.88 14 11.02 14 11.3 14H17.7Z"
							stroke="black"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M14.5 2.80005C14.5 2.52304 14.5 2.38454 14.5615 2.27229C14.6122 2.17969 14.7075 2.0935 14.8047 2.05226C14.9225 2.00226 15.0479 2.01484 15.2987 2.03999C17.1271 2.22339 18.846 3.03235 20.1569 4.34319C21.4677 5.65404 22.2767 7.37295 22.4601 9.20135C22.4852 9.45212 22.4978 9.5775 22.4478 9.69533C22.4066 9.79254 22.3204 9.88781 22.2278 9.93854C22.1155 10 21.977 10 21.7 10L15.3 10C15.02 10 14.88 10 14.773 9.94555C14.6789 9.89761 14.6024 9.82112 14.5545 9.72704C14.5 9.62009 14.5 9.48007 14.5 9.20005V2.80005Z"
							stroke="black"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					<svg
						v-if="item.icon === 'calendar'"
						width="25"
						height="24"
						viewBox="0 0 25 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M21.5 10H3.5M16.5 2V6M8.5 2V6M8.3 22H16.7C18.3802 22 19.2202 22 19.862 21.673C20.4265 21.3854 20.8854 20.9265 21.173 20.362C21.5 19.7202 21.5 18.8802 21.5 17.2V8.8C21.5 7.11984 21.5 6.27976 21.173 5.63803C20.8854 5.07354 20.4265 4.6146 19.862 4.32698C19.2202 4 18.3802 4 16.7 4H8.3C6.61984 4 5.77976 4 5.13803 4.32698C4.57354 4.6146 4.1146 5.07354 3.82698 5.63803C3.5 6.27976 3.5 7.11984 3.5 8.8V17.2C3.5 18.8802 3.5 19.7202 3.82698 20.362C4.1146 20.9265 4.57354 21.3854 5.13803 21.673C5.77976 22 6.61984 22 8.3 22Z"
							stroke="black"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					<svg
						v-if="item.icon === 'yield'"
						width="25"
						height="24"
						viewBox="0 0 25 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M19.5001 10L5.50009 10M19.5001 10L21.3642 13.1069C21.782 13.8032 21.9909 14.1514 22.0994 14.5262C22.1955 14.8582 22.2335 15.2045 22.2117 15.5495C22.1871 15.9389 22.0587 16.324 21.802 17.0944L21.5941 17.7179C21.2007 18.8981 21.004 19.4882 20.6392 19.9245C20.317 20.3098 19.9032 20.608 19.4358 20.7918C18.9066 21 18.2845 21 17.0404 21L7.95973 21C6.71566 21 6.09362 21 5.56435 20.7918C5.09696 20.608 4.68321 20.3098 4.36102 19.9245C3.99617 19.4882 3.79946 18.8981 3.40605 17.7179L3.19822 17.0944C2.94144 16.324 2.81304 15.9389 2.78844 15.5495C2.76664 15.2044 2.80464 14.8582 2.90078 14.5261C3.00926 14.1514 3.21815 13.8032 3.63593 13.1069L5.50009 10M19.5001 10L19.9174 8.53955C20.1152 7.84717 20.2141 7.50097 20.1364 7.22708C20.0683 6.98715 19.9131 6.78132 19.7011 6.64996C19.4591 6.5 19.099 6.5 18.3789 6.5L6.62126 6.5C5.90116 6.5 5.54112 6.5 5.29911 6.64996C5.08711 6.78132 4.93185 6.98715 4.86378 7.22708C4.78608 7.50097 4.88499 7.84717 5.08282 8.53955L5.50009 10M12.5001 6.5H8.96437C8.44341 6.5 7.94379 6.28929 7.57541 5.91421C7.20704 5.53914 7.00009 5.03043 7.00009 4.5C7.00009 3.96957 7.20704 3.46086 7.57541 3.08579C7.94379 2.71071 8.44341 2.5 8.96437 2.5C11.7144 2.5 12.5001 6.5 12.5001 6.5ZM12.5001 6.5H16.0358C16.5568 6.5 17.0564 6.28929 17.4248 5.91421C17.7931 5.53914 18.0001 5.03043 18.0001 4.5C18.0001 3.96957 17.7931 3.46086 17.4248 3.08579C17.0564 2.71071 16.5568 2.5 16.0358 2.5C13.2858 2.5 12.5001 6.5 12.5001 6.5Z"
							stroke="black"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					<svg
						v-if="item.icon === 'money'"
						width="25"
						height="24"
						viewBox="0 0 25 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M6.5 11V15M18.5 9V13M17.5 4C19.9487 4 21.2731 4.37476 21.9321 4.66544C22.0199 4.70415 22.0638 4.72351 22.1904 4.84437C22.2663 4.91682 22.4049 5.12939 22.4405 5.22809C22.5 5.39274 22.5 5.48274 22.5 5.66274V16.4111C22.5 17.3199 22.5 17.7743 22.3637 18.0079C22.2251 18.2454 22.0914 18.3559 21.8319 18.4472C21.5769 18.5369 21.062 18.438 20.0322 18.2401C19.3114 18.1017 18.4565 18 17.5 18C14.5 18 11.5 20 7.5 20C5.05129 20 3.72687 19.6252 3.06788 19.3346C2.98012 19.2958 2.93624 19.2765 2.8096 19.1556C2.73369 19.0832 2.59512 18.8706 2.55947 18.7719C2.5 18.6073 2.5 18.5173 2.5 18.3373L2.5 7.58885C2.5 6.68009 2.5 6.2257 2.63628 5.99214C2.7749 5.75456 2.90859 5.64412 3.16806 5.55281C3.42314 5.46305 3.93803 5.56198 4.96783 5.75985C5.68862 5.89834 6.54348 6 7.5 6C10.5 6 13.5 4 17.5 4ZM15 12C15 13.3807 13.8807 14.5 12.5 14.5C11.1193 14.5 10 13.3807 10 12C10 10.6193 11.1193 9.5 12.5 9.5C13.8807 9.5 15 10.6193 15 12Z"
							stroke="black"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					<svg
						v-if="item.icon === 'scale'"
						width="25"
						height="24"
						viewBox="0 0 25 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M2.5 17V16.8498C2.5 16.5333 2.5 16.3751 2.52421 16.2209C2.5457 16.084 2.58136 15.9497 2.63061 15.8202C2.68609 15.6743 2.7646 15.5369 2.92162 15.2622L6.5 9M2.5 17C2.5 19.2091 4.29086 21 6.5 21C8.70914 21 10.5 19.2091 10.5 17M2.5 17V16.8C2.5 16.52 2.5 16.38 2.5545 16.273C2.60243 16.1789 2.67892 16.1024 2.773 16.0545C2.87996 16 3.01997 16 3.3 16H9.7C9.98003 16 10.12 16 10.227 16.0545C10.3211 16.1024 10.3976 16.1789 10.4455 16.273C10.5 16.38 10.5 16.52 10.5 16.8V17M6.5 9L10.0784 15.2622C10.2354 15.5369 10.3139 15.6743 10.3694 15.8202C10.4186 15.9497 10.4543 16.084 10.4758 16.2209C10.5 16.3751 10.5 16.5333 10.5 16.8498V17M6.5 9L18.5 7M14.5 15V14.8498C14.5 14.5333 14.5 14.3751 14.5242 14.2209C14.5457 14.084 14.5814 13.9497 14.6306 13.8202C14.6861 13.6743 14.7646 13.5369 14.9216 13.2622L18.5 7M14.5 15C14.5 17.2091 16.2909 19 18.5 19C20.7091 19 22.5 17.2091 22.5 15M14.5 15V14.8C14.5 14.52 14.5 14.38 14.5545 14.273C14.6024 14.1789 14.6789 14.1024 14.773 14.0545C14.88 14 15.02 14 15.3 14H21.7C21.98 14 22.12 14 22.227 14.0545C22.3211 14.1024 22.3976 14.1789 22.4455 14.273C22.5 14.38 22.5 14.52 22.5 14.8V15M18.5 7L22.0784 13.2622C22.2354 13.5369 22.3139 13.6743 22.3694 13.8202C22.4186 13.9497 22.4543 14.084 22.4758 14.2209C22.5 14.3751 22.5 14.5333 22.5 14.8498V15M12.5 3V8"
							stroke="black"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					<svg
						v-if="item.icon === 'wallet'"
						width="25"
						height="24"
						viewBox="0 0 25 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M16.5 7.99995V4.5006C16.5 3.66887 16.5 3.253 16.3248 2.99742C16.1717 2.77413 15.9346 2.62245 15.6678 2.57703C15.3623 2.52505 14.9847 2.69932 14.2295 3.04787L5.35901 7.14194C4.68551 7.45279 4.34875 7.60822 4.10211 7.84927C3.88406 8.06237 3.71762 8.3225 3.6155 8.60978C3.5 8.93474 3.5 9.30563 3.5 10.0474V14.9999M17 14.4999H17.01M3.5 11.2L3.5 17.7999C3.5 18.9201 3.5 19.4801 3.71799 19.9079C3.90973 20.2843 4.21569 20.5902 4.59202 20.782C5.01984 20.9999 5.57989 20.9999 6.7 20.9999H18.3C19.4201 20.9999 19.9802 21 20.408 20.782C20.7843 20.5902 21.0903 20.2843 21.282 19.9079C21.5 19.4801 21.5 18.9201 21.5 17.7999V11.2C21.5 10.0798 21.5 9.51979 21.282 9.09197C21.0903 8.71565 20.7843 8.40969 20.408 8.21794C19.9802 7.99995 19.4201 7.99995 18.3 7.99995L6.7 7.99995C5.5799 7.99995 5.01984 7.99995 4.59202 8.21794C4.2157 8.40968 3.90973 8.71564 3.71799 9.09197C3.5 9.51979 3.5 10.0798 3.5 11.2ZM17.5 14.4999C17.5 14.7761 17.2761 14.9999 17 14.9999C16.7239 14.9999 16.5 14.7761 16.5 14.4999C16.5 14.2238 16.7239 13.9999 17 13.9999C17.2761 13.9999 17.5 14.2238 17.5 14.4999Z"
							stroke="black"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					<div>
						<span class="text-slate-400 font-regular text-xs lg:text-base">
							{{ item.label }}
						</span>
						<div class="text-black text-lg font-medium leading-none">
							{{ item.value }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-8">
			<div class="text-lg lg:text-xl font-regular mb-3 text-black">
				Financial Summary:
			</div>
			<div class="flex gap-3 lg:gap-6 flex-wrap">
				<button
					:class="[
						'text-blue-300 text-sm lg:text-base hover:underline transition-colors duration-200',
						activeTab === 'income' ? 'underline' : ''
					]"
					@click="setActiveTab('income')"
				>
					Income Statement
				</button>
				<button
					:class="[
						'text-blue-300 text-sm lg:text-base hover:underline transition-colors duration-200',
						activeTab === 'balance' ? 'underline' : ''
					]"
					@click="setActiveTab('balance')"
				>
					Balance Sheet
				</button>
				<button
					:class="[
						'text-blue-300 text-sm lg:text-base hover:underline transition-colors duration-200',
						activeTab === 'cashflow' ? 'underline' : ''
					]"
					@click="setActiveTab('cashflow')"
				>
					Cash Flow
				</button>
			</div>
		</div>

		<!-- Financial Data Table -->
		<div
			v-if="activeTab && enhancedFinancials"
			class="mt-6"
		>
			<!-- Financial Data Table -->
			<div class="overflow-x-auto">
				<table
					class="w-full min-w-[680px] bg-white rounded-lg border border-slate-200 scrollbar-hide"
				>
					<thead class="bg-slate-50">
						<tr>
							<th
								class="px-4 py-3 text-left font-semibold text-black border-b border-slate-200 whitespace-nowrap"
							>
								Breakdown
							</th>
							<th
								v-for="report in sortedReports"
								:key="report.reportDate"
								class="px-4 py-3 text-right font-semibold text-black border-b border-slate-200 whitespace-nowrap"
							>
								{{ formatReportDate(report.reportDate) }}
							</th>
						</tr>
					</thead>
					<tbody>
						<!-- Income Statement Tab -->
						<template v-if="activeTab === 'income'">
							<tr
								v-for="(item, index) in incomeStatementItems"
								:key="item.key"
								:class="[
									'border-b border-slate-100',
									index % 2 === 0 ? 'bg-white' : 'bg-slate-50/30',
									'hover:bg-blue-50'
								]"
							>
								<td class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap">
									{{ item.label }}
								</td>
								<td
									v-for="report in sortedReports"
									:key="report.reportDate"
									class="text-right py-4 px-6 text-gray-700 font-medium whitespace-nowrap"
								>
									{{
										formatFinancialValue(getNestedValue(report.IncomeStatement, item.key))
									}}
								</td>
							</tr>
						</template>

						<!-- Balance Sheet Tab -->
						<template v-if="activeTab === 'balance'">
							<tr
								v-for="(item, index) in balanceSheetItems"
								:key="item.key"
								:class="[
									'border-b border-slate-100',
									index % 2 === 0 ? 'bg-white' : 'bg-slate-50/30',
									'hover:bg-blue-50'
								]"
							>
								<td class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap">
									{{ item.label }}
								</td>
								<td
									v-for="report in sortedReports"
									:key="report.reportDate"
									class="text-right py-4 px-6 text-gray-700 font-medium whitespace-nowrap"
								>
									{{
										formatFinancialValue(getNestedValue(report.BalanceSheet, item.key))
									}}
								</td>
							</tr>
						</template>

						<!-- Cash Flow Tab -->
						<template v-if="activeTab === 'cashflow'">
							<tr
								v-for="(item, index) in cashFlowItems"
								:key="item.key"
								:class="[
									'border-b border-slate-100',
									index % 2 === 0 ? 'bg-white' : 'bg-slate-50/30',
									'hover:bg-blue-50'
								]"
							>
								<td class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap">
									{{ item.label }}
								</td>
								<td
									v-for="report in sortedReports"
									:key="report.reportDate"
									class="text-right py-4 px-6 text-gray-700 font-medium whitespace-nowrap"
								>
									{{ formatFinancialValue(getNestedValue(report.CashFlow, item.key)) }}
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>

			<!-- Currency Note -->
			<p class="text-sm text-slate-400 mt-4">All numbers in thousands</p>
		</div>
	</div>
</template>

<script setup lang="ts">
// Type definitions
interface FinancialReport {
	reportPeriod: string;
	reportYear: number;
	reportDate: string;
	reportQuarter: string;
	periodEndDate: string;
	IncomeStatement: any;
	BalanceSheet: any;
	CashFlow: any;
}

interface EnhancedFinancialsData {
	results: {
		Company: {
			Report: FinancialReport[];
			name: string;
			symbol: string;
		};
	};
}

const props = defineProps({
	peRatio: {
		type: String,
		default: ""
	},
	earningsDate: {
		type: String,
		default: ""
	},
	eps: {
		type: String,
		default: ""
	},
	revenue: {
		type: String,
		default: ""
	},
	dividendYield: {
		type: String,
		default: ""
	},
	profitMargin: {
		type: String,
		default: ""
	},
	enhancedFinancials: {
		type: Object as PropType<EnhancedFinancialsData | null>,
		default: null
	}
});

const activeTab = ref("");
const activePeriod = ref("annual");

const cards = [
	{ label: "P/E Ratio", value: props.peRatio, icon: "pie" },
	{ label: "Next Earnings Date", value: props.earningsDate, icon: "calendar" },
	{ label: "EPS", value: props.eps, icon: "money" },
	{ label: "Revenue (TTM)", value: props.revenue, icon: "wallet" },
	{ label: "Dividend Yield", value: props.dividendYield, icon: "yield" },
	{ label: "Profit Margin", value: props.profitMargin, icon: "scale" }
];

const periods = [
	{ value: "annual", label: "Annual" },
	{ value: "quarterly", label: "Quarterly" }
];

// Financial statement line items
const incomeStatementItems = [
	{ key: "TotalRevenue", label: "Total Revenue" },
	{ key: "CostOfRevenue", label: "Cost of Revenue" },
	{ key: "GrossProfit", label: "Gross Profit" },
	{ key: "OperatingExpense", label: "Operating Expense" },
	{ key: "OperatingIncome", label: "Operating Income" },
	{
		key: "NetNonOperatingInterestIncomeExpense",
		label: "Net Non Operating Interest Income Expense"
	},
	{ key: "OtherIncomeExpense", label: "Other Income Expense" },
	{ key: "PretaxIncome", label: "Pretax Income" },
	{ key: "TaxProvision", label: "Tax Provision" },
	{ key: "NetIncome", label: "Net Income" },
	{ key: "BasicEPS", label: "Basic EPS" },
	{ key: "DilutedEPS", label: "Diluted EPS" }
];

const balanceSheetItems = [
	{ key: "TotalAssets", label: "Total Assets" },
	{ key: "CurrentAssets", label: "Current Assets" },
	{ key: "CashAndCashEquivalents", label: "Cash And Cash Equivalents" },
	{ key: "AccountsReceivable", label: "Accounts Receivable" },
	{ key: "Inventory", label: "Inventory" },
	{ key: "TotalNonCurrentAssets", label: "Total Non Current Assets" },
	{ key: "NetPPE", label: "Net PPE" },
	{
		key: "GoodwillAndOtherIntangibleAssets",
		label: "Goodwill And Other Intangible Assets"
	},
	{ key: "TotalLiabilities", label: "Total Liabilities" },
	{ key: "CurrentLiabilities", label: "Current Liabilities" },
	{ key: "AccountsPayable", label: "Accounts Payable" },
	{ key: "CurrentDebt", label: "Current Debt" },
	{ key: "TotalNonCurrentLiabilities", label: "Total Non Current Liabilities" },
	{ key: "LongTermDebt", label: "Long Term Debt" },
	{ key: "StockholdersEquity", label: "Stockholders Equity" },
	{ key: "RetainedEarnings", label: "Retained Earnings" }
];

const cashFlowItems = [
	{ key: "OperatingCashFlow", label: "Operating Cash Flow" },
	{
		key: "NetIncomeFromContinuingOperations",
		label: "Net Income From Continuing Operations"
	},
	{ key: "ChangeInWorkingCapital", label: "Change In Working Capital" },
	{ key: "ChangeInReceivables", label: "Change In Receivables" },
	{ key: "ChangeInInventory", label: "Change In Inventory" },
	{ key: "ChangeInPayable", label: "Change In Payable" },
	{ key: "InvestingCashFlow", label: "Investing Cash Flow" },
	{ key: "CapitalExpenditure", label: "Capital Expenditure" },
	{
		key: "NetInvestmentPurchaseAndSale",
		label: "Net Investment Purchase And Sale"
	},
	{ key: "FinancingCashFlow", label: "Financing Cash Flow" },
	{ key: "CashDividendsPaid", label: "Cash Dividends Paid" },
	{ key: "CommonStockIssuance", label: "Common Stock Issuance" },
	{ key: "RepurchaseOfCapitalStock", label: "Repurchase Of Capital Stock" },
	{ key: "ChangesInCash", label: "Changes In Cash" },
	{ key: "FreeCashFlow", label: "Free Cash Flow" }
];

// Computed property to get sorted reports (most recent first)
const sortedReports = computed(() => {
	if (!props.enhancedFinancials?.results?.Company?.Report) {
		return [];
	}

	const reports = [...props.enhancedFinancials.results.Company.Report];

	// Filter by period type if needed (currently only annual data available)
	return reports.sort(
		(a, b) => new Date(b.reportDate).getTime() - new Date(a.reportDate).getTime()
	);
});

// Helper function to format report dates
const formatReportDate = (dateStr: string) => {
	const date = new Date(dateStr);
	return date.getFullYear().toString();
};

// Helper function to format financial values
const formatFinancialValue = (value: number | null | undefined) => {
	if (value === null || value === undefined || isNaN(value)) {
		return "--";
	}

	// Values are already in thousands according to the API docs
	const absValue = Math.abs(value);

	if (absValue >= 1000000) {
		return `${(value / 1000000).toFixed(2)}B`;
	} else if (absValue >= 1000) {
		return `${(value / 1000).toFixed(2)}M`;
	}

	return value.toLocaleString();
};

// Helper function to get nested values from objects
const getNestedValue = (obj: any, key: string) => {
	if (!obj || typeof obj !== "object") {
		return null;
	}
	return obj[key];
};

// Method to set active tab
const setActiveTab = (tab: string) => {
	activeTab.value = activeTab.value === tab ? "" : tab;
};
</script>

<style scoped>
/* Custom table styling for professional look */
.overflow-x-auto::-webkit-scrollbar {
	height: 8px;
}

.overflow-x-auto::-webkit-scrollbar-track {
	background: #f1f5f9;
	border-radius: 4px;
}

.overflow-x-auto::-webkit-scrollbar-thumb {
	background: #cbd5e1;
	border-radius: 4px;
}

.overflow-x-auto::-webkit-scrollbar-thumb:hover {
	background: #94a3b8;
}

/* Ensure table borders are consistent */
table {
	border-collapse: separate;
	border-spacing: 0;
}

/* Last row shouldn't have bottom border */
tbody tr:last-child {
	border-bottom: none;
}

/* Round corners for table */
thead tr th:first-child {
	border-top-left-radius: 0.5rem;
}

thead tr th:last-child {
	border-top-right-radius: 0.5rem;
}

tbody tr:last-child td:first-child {
	border-bottom-left-radius: 0.5rem;
}

tbody tr:last-child td:last-child {
	border-bottom-right-radius: 0.5rem;
}
</style>
